import { Context, Middleware } from '../types';

export async function invokeMiddlewares<TInput, TMisc>(
  middlewares: Middleware<TInput, TMisc>[],
  input: TInput,
  context: Context,
  misc?: TMisc
): Promise<TInput> {
  return await middlewares.reduce<Promise<TInput>>(
    async (prevPromise, middleware) => {
      return await middleware(await prevPromise, context, misc);
    },
    Promise.resolve(input)
  );
}
